"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));

var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _startsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/starts-with"));

var _setTimeout2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/set-timeout"));

var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));

var _find = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/find"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _bind = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/bind"));

var _Button = _interopRequireDefault(require("../Button/Button"));

var _bind2 = _interopRequireDefault(require("classnames/bind"));

var _focusManager = _interopRequireDefault(require("../utils/focusManager/focusManager"));

var _FormInput = _interopRequireDefault(require("../Forms/FormInput"));

var _FormItem = _interopRequireDefault(require("../Forms/FormItem"));

var _FormLabel = _interopRequireDefault(require("../Forms/FormLabel"));

var _FormMessage = _interopRequireDefault(require("../Forms/_FormMessage"));

var _InputGroup = _interopRequireDefault(require("../InputGroup/InputGroup"));

var _keycode = _interopRequireDefault(require("keycode"));

var _List = _interopRequireDefault(require("../List/List"));

var _Popover = _interopRequireDefault(require("../Popover/Popover"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRequiredIf = _interopRequireDefault(require("react-required-if"));

var _tabbable2 = _interopRequireDefault(require("tabbable"));

var _withStyles = _interopRequireDefault(require("../utils/withStyles"));

var _constants = require("../utils/constants");

var _react = _interopRequireWildcard(require("react"));

var _inputGroup = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/input-group.css") : void 0);

var _list = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/list.css") : void 0);

var _popover = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("fundamental-styles/dist/popover.css") : void 0);

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context5; (0, _forEach.default)(_context5 = ownKeys(Object(source), true)).call(_context5, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context6; (0, _forEach.default)(_context6 = ownKeys(Object(source))).call(_context6, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

var classnames = (0, _bind.default)(_bind2.default).call(_bind2.default, _objectSpread(_objectSpread(_objectSpread({}, _list.default), _popover.default), _inputGroup.default));
/** A **ComboboxInput** allows users to select an item from a predefined list.
It provides an editable input field for filtering the list, and a dropdown menu with a list of the available options.
If the entries are not validated by the application, users can also enter custom values. */

var ComboboxInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      arrowLabel = _ref.arrowLabel,
      buttonProps = _ref.buttonProps,
      compact = _ref.compact,
      className = _ref.className,
      cssNamespace = _ref.cssNamespace,
      disabled = _ref.disabled,
      formItemProps = _ref.formItemProps,
      filterable = _ref.filterable,
      id = _ref.id,
      inputProps = _ref.inputProps,
      label = _ref.label,
      maxHeight = _ref.maxHeight,
      noMatchesText = _ref.noMatchesText,
      onClick = _ref.onClick,
      onSelectionChange = _ref.onSelectionChange,
      optionRenderer = _ref.optionRenderer,
      options = _ref.options,
      placeholder = _ref.placeholder,
      popoverProps = _ref.popoverProps,
      required = _ref.required,
      selectedKey = _ref.selectedKey,
      selectionType = _ref.selectionType,
      validationOverlayProps = _ref.validationOverlayProps,
      validationState = _ref.validationState,
      props = (0, _objectWithoutProperties2.default)(_ref, ["ariaLabel", "arrowLabel", "buttonProps", "compact", "className", "cssNamespace", "disabled", "formItemProps", "filterable", "id", "inputProps", "label", "maxHeight", "noMatchesText", "onClick", "onSelectionChange", "optionRenderer", "options", "placeholder", "popoverProps", "required", "selectedKey", "selectionType", "validationOverlayProps", "validationState"]);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isExpanded = _useState2[0],
      setIsExpanded = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      filterString = _useState4[0],
      setFilterString = _useState4[1];

  var _useState5 = (0, _react.useState)(),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      selectedOption = _useState6[0],
      setSelectedOption = _useState6[1];

  var textInputRef = (0, _react.useRef)(null);
  var inputAddonBtnRef = (0, _react.useRef)(null);
  var popoverRef = (0, _react.useRef)(null);
  var popoverBodyRef = (0, _react.useRef)(null);
  (0, _react.useEffect)(function () {
    var preSelectedOption = (options === null || options === void 0 ? void 0 : (0, _find.default)(options).call(options, function (option) {
      return (option === null || option === void 0 ? void 0 : option.key) === selectedKey;
    })) || null;

    if (preSelectedOption) {
      select(null, preSelectedOption, 'preSelection');
      setFilterString((preSelectedOption === null || preSelectedOption === void 0 ? void 0 : preSelectedOption.text) || '');

      if (textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) {
        textInputRef.current.value = (preSelectedOption === null || preSelectedOption === void 0 ? void 0 : preSelectedOption.text) || '';
      }
    }
  }, [selectedKey, textInputRef]);
  var inputGroupClass = classnames("".concat(cssNamespace, "-input-group--control"), (0, _defineProperty3.default)({
    'is-disabled': disabled
  }, "is-".concat(validationState === null || validationState === void 0 ? void 0 : validationState.state), validationState === null || validationState === void 0 ? void 0 : validationState.state), className);
  var resolvedSelectionType = filterable ? selectionType : 'manual'; // Event handling

  var handleInputGroupClick = function handleInputGroupClick(e) {
    if (isExpanded) {
      var _textInputRef$current;

      closePopover();
      setFilterString(textInputRef === null || textInputRef === void 0 ? void 0 : (_textInputRef$current = textInputRef.current) === null || _textInputRef$current === void 0 ? void 0 : _textInputRef$current.value);
    }

    if (!disabled) {
      onClick(e);
    }
  };

  var handleAddonButtonClick = function handleAddonButtonClick(event) {
    event.stopPropagation();

    if (!isExpanded) {
      openPopoverToIndex();
    } else {
      setIsExpanded(false);
    }
  };

  var handleInputKeyDown = function handleInputKeyDown(event) {
    var _event$target;

    var textFieldValue = event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value;

    switch ((0, _keycode.default)(event)) {
      case 'backspace':
        textInputRef.current.value = filterString;
        break;

      case 'enter':
        switch (resolvedSelectionType) {
          case 'manual':
            event.preventDefault();
            break;

          default:
            autoSelectFirstOption(event, textFieldValue, 'inputKeyDown');
            break;
        }

        break;

      case 'esc':
        reset(event);
        break;

      case 'tab':
        switch (resolvedSelectionType) {
          case 'auto':
          case 'auto-inline':
            autoSelectFirstOption(event, textFieldValue, 'inputKeyDown');
            break;

          default:
        }

        closePopover();
        break;

      case 'down':
      case 'up':
        var shouldShowOptions = true;

        switch (resolvedSelectionType) {
          case 'manual':
          case 'auto':
            {
              var _textFieldValue$trim;

              shouldShowOptions = !!(textFieldValue === null || textFieldValue === void 0 ? void 0 : (_textFieldValue$trim = (0, _trim.default)(textFieldValue).call(textFieldValue)) === null || _textFieldValue$trim === void 0 ? void 0 : _textFieldValue$trim.length) || false;
            }
            break;

          case 'auto-inline':
            break;

          default:
        }

        if (shouldShowOptions) {
          var targetIndex = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.key) ? 1 : 0;

          if ((0, _keycode.default)(event) === 'up') {
            targetIndex = lastTabbableNodeIndex(popoverBodyRef === null || popoverBodyRef === void 0 ? void 0 : popoverBodyRef.current);
          }

          openPopoverToIndex(targetIndex);
        }

        break;

      case 'left':
      case 'right':
        setFilterString(textFieldValue);
        break;

      default:
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var _event$target2;

    var inputValue = event === null || event === void 0 ? void 0 : (_event$target2 = event.target) === null || _event$target2 === void 0 ? void 0 : _event$target2.value;
    setFilterString(inputValue);

    if (inputValue === null || inputValue === void 0 ? void 0 : (0, _trim.default)(inputValue).call(inputValue)) {
      setIsExpanded(true);

      switch (resolvedSelectionType) {
        case 'manual':
          select(event, {
            key: -1,
            text: inputValue
          }, 'inputChange');
          break;

        case 'auto':
          select(event, getFirstFilteredOption(inputValue), 'inputChange');
          break;

        case 'auto-inline':
          //try type ahead nudge
          var firstOption = getFirstFilteredOption(inputValue);

          if (firstOption && startsWithIgnoreCase(firstOption === null || firstOption === void 0 ? void 0 : firstOption.text, inputValue)) {
            var _firstOption$text;

            textInputRef.current.value = firstOption === null || firstOption === void 0 ? void 0 : firstOption.text;
            createSelection(textInputRef.current, inputValue === null || inputValue === void 0 ? void 0 : inputValue.length, firstOption === null || firstOption === void 0 ? void 0 : (_firstOption$text = firstOption.text) === null || _firstOption$text === void 0 ? void 0 : _firstOption$text.length);
          }

          select(event, firstOption, 'inputChange');
          break;

        default:
      }
    } else {
      select(event, {
        key: -1,
        text: inputValue
      }, 'inputChange');
      closePopover();
    }
  };

  var handleInputBlur = function handleInputBlur(event) {
    switch (resolvedSelectionType) {
      case 'manual':
        if (!(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.key) && (filterString === null || filterString === void 0 ? void 0 : (0, _trim.default)(filterString).call(filterString).length)) {
          onSelectionChange && onSelectionChange(event, {
            'text': filterString,
            'key': -1 //key is set to -1 for custom input in manual combobox

          }, 'inputBlur');
        }

        break;

      case 'auto':
        break;

      case 'auto-inline':
        break;

      default:
    }
  };

  var handleOptionFocus = function handleOptionFocus(event, option) {
    switch (resolvedSelectionType) {
      case 'manual':
        break;

      case 'auto':
        select(event, option, 'optionFocus');
        break;

      case 'auto-inline':
        textInputRef.current.value = option === null || option === void 0 ? void 0 : option.text;
        select(event, option, 'optionFocus');
        break;

      default:
    }
  };

  var handleOptionKeyDown = function handleOptionKeyDown(event, option) {
    switch ((0, _keycode.default)(event)) {
      case 'esc':
        reset(event);
        break;

      case 'tab':
        handleOptionSelect(event, option, 'optionKeyDown');
        break;

      case 'enter':
      case 'space':
        event.preventDefault();
        handleOptionSelect(event, option, 'optionKeyDown');
        break;

      default:
    }
  };

  var handleOptionSelect = function handleOptionSelect(event, option, reason) {
    select(event, option, reason);
    textInputRef.current.value = option === null || option === void 0 ? void 0 : option.text;
    setFilterString(option === null || option === void 0 ? void 0 : option.text);
    closePopover();
  };

  var handlePopoverOutsideClick = function handlePopoverOutsideClick() {
    var _textInputRef$current2;

    isExpanded && closePopover();

    switch (resolvedSelectionType) {
      case 'manual':
        setFilterString(textInputRef === null || textInputRef === void 0 ? void 0 : (_textInputRef$current2 = textInputRef.current) === null || _textInputRef$current2 === void 0 ? void 0 : _textInputRef$current2.value);
        break;

      case 'auto':
        setFilterString((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text) || '');
        textInputRef.current.value = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text) || '';
        break;

      case 'auto-inline':
        setFilterString(selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.text);
        break;

      default:
    }
  }; // DOM and State Manipulation


  var attachFocusManager = function attachFocusManager() {
    var focusNodeIndex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    (popoverBodyRef === null || popoverBodyRef === void 0 ? void 0 : popoverBodyRef.current) && (textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current) && new _focusManager.default(popoverBodyRef === null || popoverBodyRef === void 0 ? void 0 : popoverBodyRef.current, textInputRef === null || textInputRef === void 0 ? void 0 : textInputRef.current, true, focusNodeIndex);
  };

  var autoSelectFirstOption = function autoSelectFirstOption(event, searchString, reason) {
    if (searchString) {
      var firstOption = getFirstFilteredOption(searchString);

      if (firstOption) {
        handleOptionSelect(event, firstOption, reason);
      }
    }
  };

  var closePopover = function closePopover() {
    setIsExpanded(false);
    var popover = popoverRef && popoverRef.current;
    popover && popover.handleEscapeKey();
  };

  var createSelection = function createSelection(field, start, end) {
    if (field === null || field === void 0 ? void 0 : field.createTextRange) {
      var selRange = field.createTextRange();
      selRange.collapse(true);
      selRange.moveStart('character', start);
      selRange.moveEnd('character', end);
      selRange.select();
    } else if (field === null || field === void 0 ? void 0 : field.setSelectionRange) {
      field.setSelectionRange(start, end);
    } else if (field === null || field === void 0 ? void 0 : field.selectionStart) {
      field.selectionStart = start;
      field.selectionEnd = end;
    }
  };

  var openPopoverToIndex = function openPopoverToIndex(index) {
    setIsExpanded(true);
    queueFocusManagerAttachment(index);
  };

  var reset = function reset(event) {
    closePopover();
    textInputRef.current.value = '';
    select(event, {
      key: -1,
      text: ''
    }, 'escKeyDown');
    setFilterString('');
  };

  var select = function select(event, option, reason) {
    // at least key or text has to be different to count as a true selection change
    if ((selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.key) !== (option === null || option === void 0 ? void 0 : option.key) || selectedOption.text !== (option === null || option === void 0 ? void 0 : option.text)) {
      onSelectionChange && onSelectionChange(event, option, reason);
      setSelectedOption(option);
    }
  };

  var queueFocusManagerAttachment = function queueFocusManagerAttachment(initialFocusIndex) {
    (0, _setTimeout2.default)(function () {
      attachFocusManager(initialFocusIndex);
    }, 0);
  }; //String, collection, and DOM utils


  var getFirstFilteredOption = function getFirstFilteredOption(searchString) {
    var matchedOptions = getFilteredOptions(searchString);
    return (matchedOptions === null || matchedOptions === void 0 ? void 0 : matchedOptions.length) ? matchedOptions[0] : {
      key: -1,
      text: searchString
    };
  };

  var lastTabbableNodeIndex = function lastTabbableNodeIndex(container) {
    var _tabbable;

    return container ? ((_tabbable = (0, _tabbable2.default)(container)) === null || _tabbable === void 0 ? void 0 : _tabbable.length) - 1 || 0 : 0;
  };

  var startsWithIgnoreCase = function startsWithIgnoreCase(optionText, inputValue) {
    var _context;

    return optionText === null || optionText === void 0 ? void 0 : (0, _startsWith.default)(_context = optionText.toLowerCase()).call(_context, inputValue === null || inputValue === void 0 ? void 0 : inputValue.toLowerCase());
  };

  var anyWordStartsWith = function anyWordStartsWith(sentence, search) {
    var _words$find;

    var sentenceLC = sentence === null || sentence === void 0 ? void 0 : sentence.toLowerCase();
    var searchLC = search === null || search === void 0 ? void 0 : search.toLowerCase();
    var words = sentenceLC.split(/[^a-zA-Z0-9.]/i);
    return (words === null || words === void 0 ? void 0 : words.length) && !!(words === null || words === void 0 ? void 0 : (_words$find = (0, _find.default)(words).call(words, function (word) {
      return (0, _startsWith.default)(word).call(word, searchLC);
    })) === null || _words$find === void 0 ? void 0 : _words$find.length);
  };

  var getFilteredOptions = function getFilteredOptions(searchString) {
    var _searchString$trim;

    //if non-empty string return options whose text begins with searchString, case insensitive
    if (searchString === null || searchString === void 0 ? void 0 : (_searchString$trim = (0, _trim.default)(searchString).call(searchString)) === null || _searchString$trim === void 0 ? void 0 : _searchString$trim.length) {
      return options === null || options === void 0 ? void 0 : (0, _filter.default)(options).call(options, function (eachOption) {
        var _searchString$toLower, _eachOption$text, _context2;

        return (searchString === null || searchString === void 0 ? void 0 : (_searchString$toLower = searchString.toLowerCase().match(/\s/i)) === null || _searchString$toLower === void 0 ? void 0 : _searchString$toLower.length) ? eachOption === null || eachOption === void 0 ? void 0 : (_eachOption$text = eachOption.text) === null || _eachOption$text === void 0 ? void 0 : (0, _startsWith.default)(_context2 = _eachOption$text.toLowerCase()).call(_context2, searchString === null || searchString === void 0 ? void 0 : searchString.toLowerCase()) : anyWordStartsWith(eachOption === null || eachOption === void 0 ? void 0 : eachOption.text, searchString);
      });
    } //if empty string return all the options


    return options;
  }; // Rendering


  var renderListOption = function renderListOption(option) {
    var _option$text, _context3, _option$text2, _option$text3, _option$text4;

    if (optionRenderer) {
      return optionRenderer(option);
    }

    var firstOccurrence = (_option$text = option.text) === null || _option$text === void 0 ? void 0 : (0, _indexOf.default)(_context3 = _option$text.toLowerCase()).call(_context3, filterString === null || filterString === void 0 ? void 0 : filterString.toLowerCase());
    var leftPart = (_option$text2 = option.text) === null || _option$text2 === void 0 ? void 0 : _option$text2.substring(0, firstOccurrence);
    var matchingPart = (_option$text3 = option.text) === null || _option$text3 === void 0 ? void 0 : _option$text3.substring(firstOccurrence, firstOccurrence + (filterString === null || filterString === void 0 ? void 0 : filterString.length));
    var rightPart = (_option$text4 = option.text) === null || _option$text4 === void 0 ? void 0 : _option$text4.substring(firstOccurrence + (filterString === null || filterString === void 0 ? void 0 : filterString.length));

    var content = /*#__PURE__*/_react.default.createElement(_List.default.Text, null, (filterString === null || filterString === void 0 ? void 0 : filterString.length) ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, leftPart, /*#__PURE__*/_react.default.createElement("b", null, matchingPart), rightPart) : option.text);

    return content;
  };

  var filteredOptions = getFilteredOptions(filterString);
  var showPopover = isExpanded && !!filteredOptions.length;

  var comboboxAddonButton = /*#__PURE__*/_react.default.createElement(_Button.default, (0, _extends2.default)({}, buttonProps, {
    "aria-label": arrowLabel,
    className: classnames(buttonProps === null || buttonProps === void 0 ? void 0 : buttonProps.className, {
      'is-active': showPopover
    }),
    glyph: "navigation-down-arrow",
    id: "".concat(id, "-combobox-arrow"),
    onClick: handleAddonButtonClick,
    option: "transparent",
    ref: inputAddonBtnRef,
    tabIndex: "-1"
  }));

  var labelProps = {};

  if (label === null || label === void 0 ? void 0 : (0, _trim.default)(label).call(label)) {
    labelProps['aria-labelledby'] = "".concat(id, "-label");
  } else if (ariaLabel === null || ariaLabel === void 0 ? void 0 : (0, _trim.default)(ariaLabel).call(ariaLabel)) {
    labelProps['aria-label'] = ariaLabel;
  }

  (0, _react.useImperativeHandle)(ref, function () {
    return {
      get input() {
        return textInputRef.current;
      },

      get button() {
        return inputAddonBtnRef.current;
      }

    };
  });

  var inputGroup = /*#__PURE__*/_react.default.createElement("div", {
    "aria-expanded": showPopover,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(id, "-listbox"),
    id: "".concat(id, "-combobox") // disabling since we're using aria-owns
    // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
    ,
    role: "combobox"
  }, /*#__PURE__*/_react.default.createElement(_InputGroup.default, (0, _extends2.default)({}, props, {
    className: inputGroupClass,
    compact: compact,
    disabled: disabled,
    onClick: handleInputGroupClick,
    validationOverlayProps: validationOverlayProps,
    validationState: isExpanded ? null : validationState
  }), /*#__PURE__*/_react.default.createElement(_FormInput.default, (0, _extends2.default)({
    autoComplete: "off"
  }, inputProps, labelProps, {
    "aria-autocomplete": resolvedSelectionType === 'auto-inline' ? 'both' : 'list',
    "aria-controls": "".concat(id, "-listbox"),
    compact: compact,
    id: "".concat(id, "-input"),
    onBlur: handleInputBlur,
    onChange: handleInputChange,
    onKeyDown: handleInputKeyDown,
    placeholder: placeholder,
    ref: textInputRef,
    required: required
  })), resolvedSelectionType === 'auto-inline' && /*#__PURE__*/_react.default.createElement(_InputGroup.default.Addon, {
    isButton: true
  }, comboboxAddonButton)));

  return /*#__PURE__*/_react.default.createElement(_FormItem.default, formItemProps, (label === null || label === void 0 ? void 0 : (0, _trim.default)(label).call(label)) && /*#__PURE__*/_react.default.createElement(_FormLabel.default, {
    disabled: disabled,
    id: "".concat(id, "-label"),
    required: required
  }, label), /*#__PURE__*/_react.default.createElement(_Popover.default, (0, _extends2.default)({}, popoverProps, {
    body: /*#__PURE__*/_react.default.createElement("div", {
      ref: popoverBodyRef,
      style: {
        maxHeight: maxHeight,
        overflowY: 'auto'
      }
    }, validationState && /*#__PURE__*/_react.default.createElement(_FormMessage.default, (0, _extends2.default)({}, validationOverlayProps === null || validationOverlayProps === void 0 ? void 0 : validationOverlayProps.formMessageProps, {
      type: validationState.state
    }), validationState.text), /*#__PURE__*/_react.default.createElement(_List.default, (0, _extends2.default)({}, labelProps, {
      className: classnames("".concat(cssNamespace, "-list--dropdown")),
      compact: compact,
      id: "".concat(id, "-listbox"),
      noBorder: true,
      role: "listbox"
    }), (filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) ? (0, _map.default)(filteredOptions).call(filteredOptions, function (option) {
      var _context4;

      var listItemClasses = classnames({
        'is-selected': (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.key) ? (option === null || option === void 0 ? void 0 : option.key) === (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.key) : false
      });
      return /*#__PURE__*/_react.default.createElement(_List.default.Item, {
        className: listItemClasses,
        id: (0, _concat.default)(_context4 = "".concat(id, "-listbox-option-")).call(_context4, option.key),
        key: option.key,
        onClick: function onClick(e) {
          return handleOptionSelect(e, option, 'optionClick');
        },
        onFocus: function onFocus(e) {
          return handleOptionFocus(e, option);
        },
        onKeyDown: function onKeyDown(e) {
          return handleOptionKeyDown(e, option);
        },
        role: "option"
      }, renderListOption(option));
    }) : /*#__PURE__*/_react.default.createElement(_List.default.Item, {
      tabIndex: "-1"
    }, /*#__PURE__*/_react.default.createElement(_List.default.Text, {
      role: "option"
    }, noMatchesText || 'No match')))),
    control: inputGroup,
    disableKeyPressHandler: true,
    disableTriggerOnClick: true,
    disabled: disabled,
    noArrow: true,
    onClickOutside: handlePopoverOutsideClick,
    popperClassName: classnames("".concat(cssNamespace, "-popover__body--dropdown")),
    ref: popoverRef,
    show: showPopover,
    useArrowKeyNavigation: true,
    widthSizingType: "maxTarget"
  })));
});

ComboboxInput.displayName = 'ComboboxInput';
process.env.NODE_ENV !== "production" ? ComboboxInput.propTypes = {
  /** Unique id string for combobox control.
   * It is used to bind the various components within.
   * Please don't provide id's for internal components through their individual props
   * */
  id: _propTypes.default.string.isRequired,

  /** Localized string to use as a ariaLabel for the Combobox, this is required if `label` is not set
   */
  ariaLabel: (0, _reactRequiredIf.default)(_propTypes.default.string, function (props) {
    var _props$label, _props$ariaLabel;

    return !((_props$label = props.label) === null || _props$label === void 0 ? void 0 : (0, _trim.default)(_props$label).call(_props$label)) && !((_props$ariaLabel = props.ariaLabel) === null || _props$ariaLabel === void 0 ? void 0 : (0, _trim.default)(_props$ariaLabel).call(_props$ariaLabel));
  }),

  /** Localized string to use as a ariaLabel for the Combobox dropdown arrow button.
   *
   * @param {Object} props all props
   * @returns {Error} if arrowLabel is missing, combobox is filterable and selectionType is 'auto-inline'
   */
  arrowLabel: function arrowLabel(props) {
    var _props$arrowLabel;

    if (!((_props$arrowLabel = props.arrowLabel) === null || _props$arrowLabel === void 0 ? void 0 : (0, _trim.default)(_props$arrowLabel).call(_props$arrowLabel)) && (props === null || props === void 0 ? void 0 : props.filterable) && (props === null || props === void 0 ? void 0 : props.selectionType) === 'auto-inline') {
      return new Error("\nMissing property 'arrowLabel'.\nDropdown arrow/caret button is displayed if combobox is filterable and selectionType is 'auto-inline'.\nAn accessible localized string is needed for this button.\nPlease set 'arrowLabel' property to a non-empty localized string.\n            ");
    }
  },

  /** Additional props to be spread to the `<button>` element */
  buttonProps: _propTypes.default.object,

  /** CSS class(es) to add to the element */
  className: _propTypes.default.string,

  /** Set to **true** to enable compact mode */
  compact: _propTypes.default.bool,

  /** Set to **true** to mark component as disabled and make it non-interactive */
  disabled: _propTypes.default.bool,

  /** Set to **false** to disable option filtering. If **false** `selectionType` will be forced to `'manual'`.
   * You can disable filtering to show a static list of options regardless of the text value, for example recent selections etc. */
  filterable: _propTypes.default.bool,

  /** Additional props to be spread to the combobox FormItem wrapper */
  formItemProps: _propTypes.default.object,

  /** Additional props to be spread to the `<input>` element */
  inputProps: _propTypes.default.object,

  /** Localized string to use as a visual and semantic label for the Combobox*/
  label: _propTypes.default.string,

  /** CSS value for maxHeight property of listbox popover*/
  maxHeight: _propTypes.default.string,

  /** Localized string to show when no options match the input */
  noMatchesText: _propTypes.default.string,

  /** A function to render each option*/
  optionRenderer: _propTypes.default.func,

  /** An array of objects with a key and text to render the selectable options */
  options: _propTypes.default.arrayOf(_propTypes.default.shape({
    key: _propTypes.default.string.isRequired,
    text: _propTypes.default.string.isRequired
  })),

  /** Localized placeholder text of the input */
  placeholder: _propTypes.default.string,

  /** Additional props to be spread to the Popover component */
  popoverProps: _propTypes.default.object,

  /** Set to **true** to mark input field as required.*/
  required: _propTypes.default.bool,

  /** The key corresponding to the selected option */
  selectedKey: _propTypes.default.string,

  /** String representing option selection behaviors:
   *
   * * `'manual'`: User has to manually select the option by navigating through the listbox options
   * * `'auto'`: First option from the filtered options is automatically selected, user chooses different option by navigating through the list
   * * `'auto-inline'`: First option from the filtered options is automatically selected and its options.text value is populated inline (type-ahead), user chooses different option by navigating through the list
  */
  selectionType: _propTypes.default.oneOf(_constants.COMBOBOX_SELECTION_TYPES),

  /** Additional props to be spread to the ValidationOverlay */
  validationOverlayProps: _propTypes.default.shape({
    /** Additional classes to apply to validation popover's outermost `<div>` element  */
    className: _propTypes.default.string,

    /** Additional props to be spread to the ValdiationOverlay's FormMessage component */
    formMessageProps: _propTypes.default.object,

    /** Additional classes to apply to validation popover's popper child `<div>` wrapping the provided children  */
    innerRefClassName: _propTypes.default.string,

    /** Additional classes to apply to validation popover's popper `<div>` element  */
    popperClassName: _propTypes.default.string,

    /** CSS class(es) to add to the ValidationOverlay's reference `<div>` element */
    referenceClassName: _propTypes.default.string,

    /** Additional props to be spread to the popover's outermost `<div>` element */
    wrapperProps: _propTypes.default.object
  }),

  /** An object identifying a validation message.  The object will include properties for `state` and `text`; _e.g._, \`{ state: \'warning\', text: \'This is your last warning\' }\` */
  validationState: _propTypes.default.shape({
    /** State of validation: 'error', 'warning', 'information', 'success' */
    state: _propTypes.default.oneOf(_constants.FORM_MESSAGE_TYPES),

    /** Text of the validation message */
    text: _propTypes.default.string
  }),

  /** Callback function; triggered when user clicks in the text input field.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @returns {void}
  */
  onClick: _propTypes.default.func,

  /** Callback function; triggered when the selected option changes.
   * There can be many reasons for a selection change depending on the `selectionType` of the combobox.
   * The reason is available as a String and could be one of `preSelection`, `inputBlur`, `inputChange`, `inputKeyDown`,
   * `optionFocus`, `optionKeyDown`, `optionClick`.
   *
   * @param {SyntheticEvent} event - React's original SyntheticEvent. See https://reactjs.org/docs/events.html.
   * @param {Object} selected - the selected option object. Will contain at least the 'key' and 'text' properties.
   * @param {string} reason - what caused the selection to change
   * @returns {void}
  */
  onSelectionChange: _propTypes.default.func
} : void 0;
ComboboxInput.defaultProps = {
  filterable: true,
  options: [],
  onClick: function onClick() {},
  onSelectionChange: function onSelectionChange() {},
  selectionType: 'manual'
};

var _default = (0, _withStyles.default)(ComboboxInput);

exports.default = _default;